import { withTranslation, TFunction } from "react-i18next";
import i18n from "i18next";
import { SvgIcon } from "../../common/SvgIcon";
import { ADDRESS, CONTACT, ORG_LEGAL_NAME, ROUTES } from "../../config/site";
import {
  FooterSection,
  FooterGrid,
  FooterHeading,
  FooterPara,
  FooterRouteLink,
  FooterExternalLink,
  LanguageSwitchGroup,
  FooterBottomBar,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <FooterSection>
      <FooterGrid>
        <div className="col-brand">
          <FooterHeading>{t("Deira Trading Desk")}</FooterHeading>
          <FooterPara>
            {ADDRESS.streetAddress}, {ADDRESS.addressLocality}, United Arab Emirates
          </FooterPara>
          <FooterPara>
            <FooterExternalLink href={`tel:${CONTACT.phone}`}>
              {CONTACT.phone}
            </FooterExternalLink>{" "}
            /{" "}
            <FooterExternalLink href={`tel:${CONTACT.phoneAlt}`}>
              {CONTACT.phoneAlt}
            </FooterExternalLink>
          </FooterPara>
          <FooterPara>
            <FooterExternalLink href={`mailto:${CONTACT.email}`}>
              {CONTACT.email}
            </FooterExternalLink>
          </FooterPara>
        </div>

        <div className="col-emirates">
          <FooterHeading>{t("Sell Scrap by Emirate")}</FooterHeading>
          <FooterRouteLink to={ROUTES.sellDubai.path}>
            {t("Sell Scrap in Dubai")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.sellAbuDhabi.path}>
            {t("Sell Scrap in Abu Dhabi")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.sellSharjah.path}>
            {t("Sell Scrap in Sharjah")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.sellAjman.path}>
            {t("Sell Scrap in Ajman")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.sellRasAlKhaimah.path}>
            {t("Sell Scrap in Ras Al Khaimah")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.sellFujairah.path}>
            {t("Sell Scrap in Fujairah")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.sellUmmAlQuwain.path}>
            {t("Sell Scrap in Umm Al Quwain")}
          </FooterRouteLink>
        </div>

        <div className="col-nav">
          <FooterHeading>{t("Operations")}</FooterHeading>
          <FooterRouteLink to={ROUTES.materials.path}>
            {t("Materials We Buy")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.uaeEmirates.path}>
            {t("UAE 7 Emirates Hub")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.recycling.path}>
            {t("Recycling Process")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.about.path}>
            {t("About Good Luck Metals")}
          </FooterRouteLink>
        </div>

        <div className="col-market">
          <FooterHeading>{t("LME & Compliance")}</FooterHeading>
          <FooterRouteLink to={ROUTES.home.path}>
            {t("Live LME Rates & Calculator")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.resources.path}>
            {t("MOCCAE & Export Regulations")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.resources.path}>
            {t("ISRI Grade Glossary")}
          </FooterRouteLink>
          <FooterRouteLink to={ROUTES.contact.path}>
            {t("Request Live Quote")}
          </FooterRouteLink>
        </div>

        <div className="col-lang">
          <FooterHeading>{t("Language")}</FooterHeading>
          <LanguageSwitchGroup>
            <button
              type="button"
              onClick={() => handleChange("en")}
              aria-label="Switch language to English"
            >
              <SvgIcon
                src="united-states.svg"
                alt=""
                width="20px"
                height="20px"
              />
              EN
            </button>
            <button
              type="button"
              onClick={() => handleChange("ar")}
              aria-label="Switch language to Arabic"
            >
              <SvgIcon src="ae.png" alt="" width="20px" height="20px" />
              AR
            </button>
          </LanguageSwitchGroup>
        </div>
      </FooterGrid>

      <FooterBottomBar>
        <FooterRouteLink to="/" className="bottom-brand">
          <img
            src="/img/logo.png"
            alt="Good Luck Metals emblem"
            width="40"
            height="40"
          />
          <span>{ORG_LEGAL_NAME}</span>
        </FooterRouteLink>
        <div className="bottom-meta">
          Licensed Non-Ferrous &amp; Ferrous Scrap Trader · Port Saeed, Deira,
          Dubai, UAE · Smelting clip: &ldquo;Vicart - Aciérie&rdquo; by
          Damien-VICART, CC BY 3.0
        </div>
      </FooterBottomBar>
    </FooterSection>
  );
};

export default withTranslation()(Footer);
